import { assign } from 'lodash';

import { VictoryTheme } from 'victory';

const charcoal = '#252525';
// *
// * Typography
// *
const sansSerif = 'sans-serif';
const letterSpacing = 'normal';
const fontSize = 5;
const brushFontSize = 8;
const width = 800;
const chartHeight = 200;
const brushHeight = 50;

// *
// * Labels
// *
const baseLabelStyles = {
  fontFamily: sansSerif,
  fontSize,
  letterSpacing,
  padding: 10,
  fill: charcoal,
  stroke: 'transparent',
};
const strokeLinecap = 'round';
const strokeLinejoin = 'round';

const tooltip = {
  cornerRadius: 3,
  pointerLength: 10,
  orientation: 'top',
  style: {
    fontSize: 10,
    strokeWidth: '.4',
    stroke: 'white',
    fill: 'white',
    fontFamily: 'sans-serif',
  },
  flyoutStyle: {
    fill: '#000000',
    opacity: 0.7,
  },
};

const scatter = {
  style: {
    data: {
      fill: charcoal,
      stroke: 'transparent',
      strokeWidth: 0,
    },
  },
};

const axis = {
  fill: 'transparent',
  stroke: charcoal,
  strokeWidth: 1,
  strokeLinecap,
  strokeLinejoin,
};

const grid = {
  fill: 'none',
  stroke: '#EEEEEE',
  pointerEvents: 'painted',
};

const ticks = {
  fill: 'transparent',
  size: 1,
  stroke: 'black',
};

const tickLabels = {
  fontSize: 10,
  padding: 5,
  fontFamily: 'sans-serif',
};

const centeredLabelStyles = assign({ textAnchor: 'middle' }, baseLabelStyles);

const variantTheme = { ...VictoryTheme.grayscale };

variantTheme.axis = {
  style: {
    axis,
    axisLabel: assign({}, centeredLabelStyles, {
      fontSize: 12,
      padding: 35,
    }),
    grid,
    ticks,
    tickLabels,
  },
};
variantTheme.chart = {
  padding: { top: 10, bottom: 50, left: 50, right: 30 },
  width,
  height: chartHeight,
};
variantTheme.scatter = { ...scatter, style: { data: { cursor: 'pointer' } } };

variantTheme.tooltip = { ...tooltip };

export const VariantTheme = variantTheme;

const featureTheme = { ...VictoryTheme.grayscale };

featureTheme.axis = {
  style: {
    axis,
    axisLabel: assign({}, centeredLabelStyles, {
      fontSize: 10,
      padding: 30,
    }),
    grid,
    ticks,
    tickLabels,
  },
};

featureTheme.chart = {
  padding: { top: 5, bottom: 30, left: 40, right: 10 },
  width,
  height: chartHeight,
};

featureTheme.scatter = {
  size: 3,
  style: {
    data: {
      stroke: '#DFDADA',
      strokeWidth: 0.1,
    },
  },
};

featureTheme.tooltip = { ...tooltip };

export const FeatureTheme = featureTheme;

const brushTheme = { ...VictoryTheme.grayscale };

brushTheme.axis = {
  style: {
    axis,
    axisLabel: assign({}, centeredLabelStyles, {
      padding: 25,
      angle: 0,
      fontSize: 8,
    }),
    grid: assign({}, grid, {
      stroke: 'none',
    }),
    ticks,
    tickLabels: assign({}, tickLabels, {
      fontSize: brushFontSize,
    }),
  },
};
brushTheme.chart = {
  padding: { top: 0, bottom: 3, left: 50, right: 25 },
  width,
  height: brushHeight,
};
brushTheme.scatter = scatter;

export const BrushTheme = brushTheme;

const axisBrushTheme = { ...VictoryTheme.grayscale };

axisBrushTheme.axis = {
  style: {
    axis: assign({}, axis, {
      stroke: 'white',
    }),
    axisLabel: assign({}, centeredLabelStyles, {
      padding: 25,
      angle: 0,
      fontSize: 8,
    }),
    grid,
    ticks: assign({}, ticks, {
      stroke: 'none',
    }),
    tickLabels: assign({}, tickLabels, {
      fontSize: brushFontSize,
      padding: 10,
    }),
  },
  padding: { top: 0, bottom: 45, left: 50, right: 25 },
  width,
  height: brushHeight,
};

export const AxisBrushTheme = axisBrushTheme;
